import { Component, Input } from '@angular/core';

@Component({
  selector: 'card',
  template: `
    <div *ngIf="title && visible" class="card-header text-center" [ngStyle]="{'background-color': '#' + color}">
      <i *ngIf="glyph" [ngClass]="glyph"></i>
      {{ title }}
    </div>
    <div *ngIf="visible" class="card card-content">
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
    .card-content {
        padding: 1rem 1rem 0rem 1rem;
    }
    .card-header {
        padding: 0.1rem;
        background-color: #007bff;
        color: #FFF;
        border-radius: 0;
        font-weight: bold;
    }
  `]
})

export class CardComponent {
  @Input() public title: string = '';
  @Input() public glyph: string = '';
  @Input() public visible: boolean = true;
  @Input() public color: string = "007bff";
}
